/**
 * Breakpoint goodies
 */
export const Breakpoints = {
    sm: '576',
    md: '768',
    lg: '992',
    xl: '1200',
    smUp: function() {

        return window.matchMedia( '(min-width: ' + this.sm + 'px)' ).matches;

    },
    mdUp: function() {

        return window.matchMedia( '(min-width: ' + this.md + 'px)' ).matches;

    },
    lgUp: function() {

        return window.matchMedia( '(min-width: ' + this.lg + 'px)' ).matches;

    },
    xlUp: function() {

        return window.matchMedia( '(min-width: ' + this.xl + 'px)' ).matches;

    }
    
};

/**
 * Relative Dirs
 */
 export const Directories = {
    node_modules: '../../../../node_modules/'
 }


// WEBPACK FOOTER //
// ./assets/frontend/scripts/main/settings.js